import State from '@/classes/case/State'
import { InvalidStateError } from '../errors'
import { dateTimeFormat } from '@/utility/utility_functions'

class Invoice {
  static MARKING_UID = 'marking'
  static KIWA_REFERENCE_UID = 'kiwa_reference'
  static CUSTOMER_REFERENCE_UID = 'customer_reference'

  constructor (id, invoiceNumber, created, modified, customerId, customerName, customerReference, kiwaReference, marking, totalSum, state, articles, caseId, invoiceCustomer) {
    this.id = id
    this.invoiceNumber = invoiceNumber
    this.created = created
    this.modified = modified
    this.customerId = customerId
    this.customerName = customerName
    this.customerReference = customerReference
    this.kiwaReference = kiwaReference
    this.marking = marking
    this.totalSum = totalSum
    this.state = state
    this.articles = articles
    this.caseId = caseId
    this.invoiceCustomer = invoiceCustomer
  }

  static asInvoices (json) {
    return json.map(invoice => {
      return Invoice.asInvoice(invoice)
    })
  }

  static asInvoice (json) {
    return new Invoice(
      json.id,
      json.invoice_number,
      json.created ? dateTimeFormat(json.created, 'YYYY-MM-DD HH:mm') : '',
      json.modified ? dateTimeFormat(json.modified, 'YYYY-MM-DD HH:mm') : '',
      json.customer_id,
      json.customer_name,
      json.customer_reference,
      json.kiwa_reference,
      json.marking,
      json.total_sum,
      json.state ? InvoiceState.asState(json.state) : null,
      json.articles ? InvoiceArticle.asInvoiceArticles(json.articles) : null,
      json.case_id,
      json.invoice_customer
    )
  }

  get invoiceLink () {
    return { name: 'InvoiceDetailsView', params: { invoiceId: this.id } }
  }

  get stateCell () {
    return this.state
  }

  hasValidStates (states) {
    return states.includes(this.state.value)
  }

  updateCurrentInvoice (invoice) {
    if (this.id !== invoice.id) {
      throw new Error('Objects missmatch')
    }
    this.created = invoice.created
    this.modified = invoice.modified
    this.invoiceNumber = invoice.invoiceNumber
    this.customerId = invoice.customerId
    this.customerName = invoice.customerName
    this.customerReference = invoice.customerReference
    this.kiwaReference = invoice.kiwaReference
    this.marking = invoice.marking
    this.totalSum = invoice.totalSum
    this.state = invoice.state
    this.articles = invoice.articles
  }
}

class InvoiceArticle {
  static NUMBER_UID = 'number'
  static DESCRIPTION_UID = 'description'
  static PRICE_UID = 'price'
  static QUANTITY_UID = 'quantity'

  constructor (number, description, price, quantity, sum) {
    this.number = number
    this.description = description
    this.price = price
    this.quantity = quantity
    this.sum = sum
  }

  static asInvoiceArticles (json) {
    return json.map(invoiceArticle => {
      return InvoiceArticle.asInvoiceArticle(invoiceArticle)
    })
  }

  static asInvoiceArticle (json) {
    return new InvoiceArticle(
      json.number,
      json.description,
      json.price,
      json.quantity,
      json.price && json.quantity ? parseFloat(json.price * json.quantity) : 0
    )
  }
}

class InvoiceState {
  static DRAFT = 1
  static PUBLISH = 2
  static CANCEL = 3

  static VALID_STATES = [
    InvoiceState.DRAFT,
    InvoiceState.PUBLISH]

  constructor (value, display, level) {
    if (!InvoiceState.VALID_STATES.includes(value)) throw new InvalidStateError()
    this.value = value
    this.display = display
    this.level = level
  }

  static asState (json) {
    return new State(
      json.value,
      json.display,
      json.level
    )
  }
}

export {
  Invoice,
  InvoiceArticle,
  InvoiceState
}
